import { api } from "../services/";

export const login = (payload) => api.post("login/", payload);
